/**
 * @deprecated token is added automatically by requestInterceptor
 */
export const useRenewToken = () => {
  return { renewToken: () => ' ' }
}
